module.exports = __webpack_public_path__ + "static/media/o-nas.cd33054a.jpg";